import ProjectsSitesData from '../mock/project_data/projects_sites.json';
import BiodiversitySummaries from '../mock/project_data/biodiversity_summaries_project.json';
import CarbonSummaries from '../mock/project_data/carbon_summaries_project.json';
import EnvironmentalSummaries from '../mock/project_data/environmental_summaries_project.json';
import EnvironmentalMetricsSite from '../mock/project_data/environmental_metrics_site.json';
import EnvironmentalData from '../mock/project_data/environmental_data_site.json';
import ActivityTrends from '../mock/project_data/activity_trends_site.json';
import BiodiversityMetricsSite from '../mock/project_data/biodiversity_metrics_site.json';
import CarbonMetricsSite from '../mock/project_data/carbon_metrics_site.json';
import Lookups from '../mock/project_data/lookups.json';

export type RegistryEntry = { value: number; label: string };
export type CountryEntry = { value: number; label: string };
export type TypeEntry = { value: number; label: string };
export type ProjectNameEntry = { value: number; label: string };

export interface LookupsType {
  registryNamesArray: RegistryEntry[];
  CountryNamesArray: CountryEntry[];
  ProjectTypeArray: TypeEntry[];
  ProjectNamesArray: ProjectNameEntry[];
}

export const mergeDeep = (target: any, source: any): any => {
  if (!target && !source) return {};
  if (!target) return source;
  if (!source) return target;

  let output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target))
          Object.assign(output, { [key]: source[key] });
        else
          output[key] = mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
};

const isObject = (item: any) => {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export const getProjectLookup = (): LookupsType => Lookups as LookupsType;

export const getProjectsList = () => ProjectsSitesData;

export const getProjectById = (projectId: string) => {
    const project = ProjectsSitesData.find(p => p.project_id === projectId);
    if (!project) return null;

    const bioSummary = (BiodiversitySummaries as any)[projectId] || {};
    const carbonSummary = (CarbonSummaries as any)[projectId] || {};
    const envSummary = (EnvironmentalSummaries as any)[projectId] || {};
    
    const firstSiteMetrics = project.sites?.[0] ? (BiodiversityMetricsSite as any)[project.sites[0].site_name] : {};
    
    const mergedSites = project.sites?.map(site => {
        const siteCarbonSummary = carbonSummary.sites?.find((s: any) => s.site_id === site.site_id) || {};
        const siteBioSummary = (bioSummary.sites as any[])?.find((s: any) => s.site_id === site.site_id) || {};

        return {
            ...envSummary,
            ...site,
            ...siteCarbonSummary,
            ...siteBioSummary,
            ...(EnvironmentalData as any)[site.site_id],
            ...(ActivityTrends as any)[site.site_id],
            ...(BiodiversityMetricsSite as any)[site.site_name],
            ...(CarbonMetricsSite as any)[site.site_id],
            ...(EnvironmentalMetricsSite as any)[site.site_id]
        };
    }) || [];

    const mergedProject = {
        ...project,
        ...carbonSummary,
        ...envSummary,
        ...firstSiteMetrics,
        ...bioSummary,
        status: (project as any).project_status || 'Active',
        total_plantation_area: 0,
        total_planted_trees: 0,
        biodiversity_summary_project_level: {
            ...firstSiteMetrics,
            ...bioSummary,
            insitu_data: mergedSites
        },
        sites: mergedSites
    };

    return mergedProject;
};

export const getProjectByName = (projectName: string) => {
    const project = ProjectsSitesData.find(p => p.project_name === projectName);
    if (!project) return null;
    return getProjectById(project.project_id);
};

// Legacy compatibility functions
export const getCurrentProjectMerged = (
  projectList: any[],
  defaultProjectList: any[],
  projectName: string | undefined
) => {
  if (!projectName) return null;
  return getProjectByName(projectName);
};

export const getCurrentProjectMergedFlat = (
  projectList: any[][],
  defaultProjectList: any[][],
  projectName: string | undefined
) => {
  if (!projectName) return null;
  return getProjectByName(projectName);
};
